import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? '/api'
    : 'http://localhost:5000/api');

function base(kind, id) {
  return `${API_BASE_URL}/${kind === 'ai-stories' ? 'ai-stories-channels' : 'channels'}/${id}/youtube`;
}

const ChannelYouTubeService = {
  async get(kind, id, { refresh = false } = {}) {
    return (await axios.get(base(kind, id), { params: { refresh } })).data;
  },
  async save(kind, id, data) {
    return (await axios.put(base(kind, id), data)).data;
  },
  async connect(kind, id) {
    return (await axios.post(`${base(kind, id)}/connect`)).data;
  },
  async check(kind, id) {
    return (await axios.post(`${base(kind, id)}/check`)).data;
  },
  async disconnect(kind, id) {
    await axios.delete(base(kind, id));
  },
  async uploads(kind, id) {
    return (await axios.get(`${base(kind, id)}/uploads`)).data;
  },
  async uploadPreview(kind, id, videoId) {
    return (await axios.get(`${base(kind, id)}/upload-preview/${videoId}`)).data;
  },
  async upload(kind, id, videoId, preview) {
    return (await axios.post(`${base(kind, id)}/uploads`, {
      videoId,
      title: preview.title,
      youtubeChannelId: preview.channel.id,
      connectionRevision: preview.connectionRevision,
      renderVersion: preview.renderVersion,
    })).data;
  },
  async retry(kind, id, uploadId) {
    await axios.post(`${base(kind, id)}/uploads/${uploadId}/retry`);
  },
};

export default ChannelYouTubeService;
